import { renewToken } from "./auth";
import { clearStatus, updateStatus } from "./status";
import { clearActiveCommunities } from "./activeCommunity";
import { navigationRef } from "../../navigation/navigationRef";
import { queryClient } from "../../utils/queryClient";

const types = {
  START: "IMPERSONATION_START",
  STOP: "IMPERSONATION_STOP",
};

type TargetUser = { uuid: string; name: string; email?: string };

export interface ImpersonationState {
  superAdminToken: string | null;
  targetUser: TargetUser | null;
}

const initialState: ImpersonationState = {
  superAdminToken: null,
  targetUser: null,
};

export function startImpersonation(targetToken: string, targetUser: TargetUser) {
  return async (dispatch: any, getState: any) => {
    const { auth, impersonation } = getState();

    if (impersonation?.superAdminToken) {
      console.warn("[impersonation] already active, ignoring nested attempt");
      return;
    }

    dispatch({
      type: types.START,
      superAdminToken: auth.token,
      targetUser,
    });
    dispatch(renewToken(targetToken));
    dispatch(clearStatus());
    dispatch(clearActiveCommunities());
    queryClient.clear();

    await dispatch(updateStatus());

    if (navigationRef.isReady()) {
      navigationRef.reset({ index: 0, routes: [{ name: "Main.Stack" }] });
    }
  };
}

export function stopImpersonation() {
  return async (dispatch: any, getState: any) => {
    const { impersonation } = getState();
    if (!impersonation?.superAdminToken) return;

    dispatch(renewToken(impersonation.superAdminToken));
    dispatch({ type: types.STOP });
    dispatch(clearStatus());
    dispatch(clearActiveCommunities());
    queryClient.clear();

    await dispatch(updateStatus());

    if (navigationRef.isReady()) {
      navigationRef.reset({ index: 0, routes: [{ name: "MetaAdmin.Stack" }] });
    }
  };
}

export const reducer = (state: ImpersonationState = initialState, action: any): ImpersonationState => {
  switch (action.type) {
    case types.START:
      return {
        superAdminToken: action.superAdminToken,
        targetUser: action.targetUser,
      };
    case types.STOP:
      return { ...initialState };
    case "LOGOUT":
      return { ...initialState };
    default:
      return state;
  }
};
